import React, { Fragment, useState } from 'react';
import { Text, useClassnames } from '@wb-tech/ui-react';
import { useTranslation } from 'react-i18next';

import { WhatIsBalanceModal } from '#component/what-is-balance-modal';

import style from './index.module.pcss';

export const WhatIsBalanceContent = () => {
    const cn = useClassnames(style);
    const { t } = useTranslation();

    const [isShowBalanceModal, setIsShowBalanceModal] = useState<boolean>(false);

    return (
        <Fragment>
            <Text
                className={cn('what-is-balance__trigger')}
                presetColor="brand-1"
                onClick={() => setIsShowBalanceModal(true)}
            >
                {t('components.header.what-is-balance-content.trigger')}
            </Text>

            <WhatIsBalanceModal
                isOpen={isShowBalanceModal}
                onClose={() => setIsShowBalanceModal(false)}
            />
        </Fragment>
    );
};
